import { render, staticRenderFns } from "./Metric.vue?vue&type=template&id=e976534a&scoped=true"
import script from "./Metric.vue?vue&type=script&lang=js"
export * from "./Metric.vue?vue&type=script&lang=js"
import style0 from "./Metric.vue?vue&type=style&index=0&id=e976534a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e976534a",
  null
  
)

export default component.exports